export function generateCodeVerifier(): string {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789_-';
  const length = Math.floor(Math.random() * 51) + 50;
  return Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
}